import { useState, useEffect, useContext } from "react";
import { ThemeContext } from "../../theme";
import { LanguageContext } from "../../LanguageContext";
import { translations } from "../constants/translations";

export const useSettingsState = ({ onLogout } = {}) => {
  // ← accept onLogout
  const { theme, setTheme } = useContext(ThemeContext);
  const { language, toggleLanguage } = useContext(LanguageContext);

  const [notifications, setNotifications] = useState({
    email: true,
    push: true,
    sms: false,
    desktop: true,
  });

  const [privacy, setPrivacy] = useState({
    profileVisibility: "public",
    dataSharing: false,
    analyticsTracking: true,
  });

  const [display, setDisplay] = useState({
    fontSize: "medium",
    density: "comfortable",
    animations: true,
  });

  const [security, setSecurity] = useState({
    twoFactorAuth: false,
    sessionTimeout: "30",
    passwordStrength: "strong",
  });

  const [savedStatus, setSavedStatus] = useState(false);
  const [showPasswordSettings, setShowPasswordSettings] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" && window.innerWidth <= 768,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSavedStatus(true);
      setTimeout(() => setSavedStatus(false), 2000);
    }, 1000);
    return () => clearTimeout(timer);
  }, [language, theme, notifications, privacy, display, security]);

  const handleNotificationChange = (type, value) =>
    setNotifications((prev) => ({ ...prev, [type]: value }));

  const handlePrivacyChange = (type, value) =>
    setPrivacy((prev) => ({ ...prev, [type]: value }));

  const handleDisplayChange = (type, value) =>
    setDisplay((prev) => ({ ...prev, [type]: value }));

  const handleSecurityChange = (type, value) =>
    setSecurity((prev) => ({ ...prev, [type]: value }));

  const handleLogout = () => setShowLogoutModal(true);

  const confirmLogout = async () => {
    // ← now async
    setShowLogoutModal(false);
    if (onLogout) {
      await onLogout(); // ← calls useLogout's logout()
    } else {
      // fallback just in case
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/login";
    }
  };

  const t = translations[language] || translations.en;
  const isRTL = language === "ar";

  return {
    // theme & language
    theme,
    setTheme,
    language,
    toggleLanguage,
    t,
    isRTL,
    isMobile,

    // states
    notifications,
    privacy,
    display,
    security,
    savedStatus,
    showPasswordSettings,
    setShowPasswordSettings,
    showLogoutModal,
    setShowLogoutModal,

    // handlers
    handleNotificationChange,
    handlePrivacyChange,
    handleDisplayChange,
    handleSecurityChange,
    handleLogout,
    confirmLogout,
  };
};
